import {
  Button,
  DatePicker,
  Divider,
  NumberInput,
  Select,
  SelectItem,
  TextInput,
  Textarea,
} from "@tremor/react";
import React, { useEffect, useState } from "react";
import { baseURL } from "./backend/baseData";
import axios from "axios";
import { toast } from "react-toastify";
import { redirect } from "react-router-dom";

const CreateChallenge = () => {
  const [formData, setFormData] = useState({
    title: "",
    type: "ordered",
    district: "",
    startDate: null,
    endDate: null,
    entryPoints: "",
    rewardPoints: "",
    level: 1,
    description: "",
    image: null,
    page_id: 2,
  });
  const [districts, setDistricts] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    const fetchDistricts = async () => {
      try {
        const response = await axios.get(
          `${baseURL}/getAllAdminDistricts.php?id=2`
        );
        if (response.status === 200 && Array.isArray(response.data)) {
          console.log(response.data);
          setDistricts(response.data);
        } else {
          console.error("Invalid response format or failed to fetch districts");
          setDistricts([]);
        }
      } catch (error) {
        console.error("Error while fetching districts:", error.message);
      } finally {
        setIsLoading(false);
      }
    };

    fetchDistricts();
  }, []);
  const handleChange = (event) => {
    const { name, value, files } = event.target;
  
    // Check if the input name is "image"
    if (name === "image") {
      // Update formData.image directly with the uploaded file
      setFormData((prevData) => ({
        ...prevData,
        image: URL.createObjectURL(files[0]), // Assuming single file upload
      }));
  
      // Update the existing image state (e.g., imageURL) to display a preview of the uploaded image
    } else {
      // For other inputs
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };
  
  

  const handleSelectChange = (title, values) => {
    setFormData((prevData) => ({
      ...prevData,
      [title]: values,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Validate form data
  
    const validationErrors = {};
    if (!formData.title.trim()) {
      validationErrors.title = "Title is required";
    }
    if (!formData.type.trim()) {
      validationErrors.type = "Type is required";
    }
    if (!formData.district.trim()) {
      validationErrors.district = "SubPage is required";
    }
    // Add validation for other fields
    if (!formData.startDate) {
      validationErrors.startDate = "Start Date is required";
    }
    if (!formData.endDate) {
      validationErrors.endDate = "End Date is required";
    }
    if (!formData.entryPoints) {
      validationErrors.entryPoints = "Entry Points are required";
    } else if (isNaN(formData.entryPoints)) {
      validationErrors.entryPoints = "Entry Points must be a number";
    }
    if (!formData.rewardPoints) {
      validationErrors.rewardPoints = "Reward Points are required";
    } else if (isNaN(formData.rewardPoints)) {
      validationErrors.rewardPoints = "Reward Points must be a number";
    } else if (formData.rewardPoints <= 0) {
      validationErrors.rewardPoints = "Reward Points can't be zero";
    }
    if (!formData.level) {
      validationErrors.level = "Level is required";
    } else if (isNaN(formData.level)) {
      validationErrors.level = "Level must be a number";
    }
    if (!formData.description.trim()) {
      validationErrors.description = "Description is required";
    }
    if (!formData.image) {
      validationErrors.image = "Image is required";
    }
  
    // Add validation for other fields
  
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }
  
    // If validation passes, submit the form data
    const formDataToSend = new FormData();

    // Append all form fields to FormData
    Object.entries(formData).forEach(([key, value]) => {
      // Append everything except image to FormData
      if (key !== 'image') {
        formDataToSend.append(key, value);
      }
    });
  
    try {
      // Fetch the image data
      const response = await fetch(formData.image);
      const blob = await response.blob();
  
      // Append image blob to FormData
      formDataToSend.append('image', blob, 'image.png');
  
      // Submit the form data
      const submitResponse = await axios.post(
        `${baseURL}/createChallengeVisit.php`,
        formDataToSend,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );
  
      // Handle successful submission
      console.log('Form submitted successfully:', submitResponse.data);
      const notify = () => {
        toast.success('Challenge Created Successfully!');
      };
      if (response.status === 200) {
      notify();
      return redirect("/challenges");
      }
    } catch (error) {
      // Handle submission error
      console.error('Error submitting form:', error.message);
    }
  };
  
  return (
    <div className="w-full  bg-[#f1f5f9]">
      <div className="w-full shadow-slate-300 ">
        {/* <div className="flex justify-end w-full p-3">
          <Link className="w-fit p-3 bg-red-600 rounded-md flex gap-3 items-center" to={"/create-challenge"}>
            <RiAddCircleLine size={20} color="white" />
            <p className="text-white">Create</p>
          </Link>
        </div> */}
      </div>
      <Divider />
      <div className="w-full p-3 ">
        <div className="w-full  mt-5 gap-2 p-3 shadow-md bg-white border border-slate-50 rounded-md">
          <h4 className="font-bold text-xl mt-2">Create Visit Challenge</h4>
          <form
            onSubmit={handleSubmit}
            className="grid grid-cols-12 mt-2 gap-3"
          >
            <div className="col-span-12 md:col-span-6 space-y-2">
              <h6>Title</h6>
              <TextInput
                className="w-full min-h-10"
                name="title"
                value={formData.title}
                onChange={handleChange}
              />
              {errors.title && <p className="text-red-500">{errors.title}</p>}{" "}
            </div>
            <div className="col-span-12 md:col-span-6 space-y-2">
              <h6>Type</h6>
              <Select
                name="type"
                value={formData.type}
                onValueChange={(value) => handleSelectChange("type", value)}
                className="min-h-10"
              >
                <SelectItem value="ordered">Ordered</SelectItem>
                <SelectItem value="unordered">Unordered</SelectItem>
              </Select>
            </div>
            {errors.type && <p className="text-red-500">{errors.type}</p>}
            <div className="col-span-12 md:col-span-6 space-y-2">
              <h6>SubPage</h6>
              <Select
                name="district"
                value={formData.district}
                onValueChange={(value) => handleSelectChange("district", value)}
                className="min-h-10"
              >
                {districts.length > 0 &&
                  districts.map((item,index) => (
                    <SelectItem value={item.district_id} key={index}>
                      {item.title}
                    </SelectItem>
                  ))}
              </Select>
              {errors.district && (
                <p className="text-red-500">{errors.district}</p>
              )}{" "}
            </div>
            <div className="col-span-12 md:col-span-6 space-y-2">
              <h6>Start Date</h6>
              <DatePicker
                name="startDate"
                value={formData.startDate}
                onValueChange={(value) =>
                  handleSelectChange("startDate", value)
                }
                placeholder="Select End Date"
                className="w-full min-h-10"
                enableSelect={false}
              />
              {errors.startDate && (
                <p className="text-red-500">{errors.startDate}</p>
              )}
            </div>
            <div className="col-span-12 md:col-span-6 space-y-2">
              <h6>End Date</h6>
              <DatePicker
                name="endDate"
                value={formData.endDate}
                onValueChange={(value) => handleSelectChange("endDate", value)}
                placeholder="Select End Date"
                className="w-full min-h-10"
                enableSelect={false}
              />
              {errors.endDate && (
                <p className="text-red-500">{errors.endDate}</p>
              )}
            </div>
            <div className="col-span-12 md:col-span-6 space-y-2">
              <h6>Entry Points</h6>
              <NumberInput
                value={formData.entryPoints}
                name="entryPoints"
                onChange={handleChange}
                className="w-full min-h-10"
              />
              {errors.entryPoints && (
                <p className="text-red-500">{errors.entryPoints}</p>
              )}
            </div>
            <div className="col-span-12 md:col-span-6 space-y-2">
              <h6>Reward Points</h6>
              <NumberInput
                value={formData.rewardPoints}
                name="rewardPoints"
                onChange={handleChange}
                className="w-full min-h-10"
              />
              {errors.rewardPoints && (
                <p className="text-red-500">{errors.rewardPoints}</p>
              )}
            </div>
            <div className="col-span-12 md:col-span-6 space-y-2">
              <h6>Level</h6>
              <NumberInput
                value={formData.level}
                name="level"
                onChange={handleChange}
                defaultValue={1}
                disabled
                className="w-full min-h-10"
              />
              {errors.level && <p className="text-red-500">{errors.level}</p>}
            </div>
            <div className="col-span-12 space-y-2">
              <h6>Description</h6>
              <Textarea
                value={formData.description}
                name="description"
                onChange={handleChange}
                rows={5}
                placeholder="Type here..."
                className="w-full min-h-10"
              />
              {errors.description && (
                <p className="text-red-500">{errors.description}</p>
              )}
            </div>
            <div className="col-span-12 space-y-2">
              <h6>Image</h6>
              <div className="mb-3 w-96">
                <input
                  // value={formData.image}
                  name="image"
                  onChange={handleChange}
                  className="relative m-0 block w-full min-w-0 flex-auto rounded border border-solid border-neutral-300 bg-clip-padding px-3 py-[0.32rem] text-base font-normal text-neutral-700 transition duration-300 ease-in-out file:-mx-3 file:-my-[0.32rem] file:overflow-hidden file:rounded-none file:border-0 file:border-solid file:border-inherit file:bg-neutral-100 file:px-3 file:py-[0.32rem] file:text-neutral-700 file:transition file:duration-150 file:ease-in-out file:[border-inline-end-width:1px] file:[margin-inline-end:0.75rem] hover:file:bg-neutral-200 focus:border-primary focus:text-neutral-700 focus:shadow-te-primary focus:outline-none dark:border-neutral-600 dark:text-neutral-200 dark:file:bg-neutral-700 dark:file:text-neutral-100 dark:focus:border-primary"
                  type="file"
                  accept="image/png, image/jpeg"
                  id="formFile"
                />
                {errors.image && <p className="text-red-500">{errors.image}</p>}
              </div>
              <div className="col-span-12 space-y-2">
                <Button variant="primary">Submit</Button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default CreateChallenge;
